import { render, staticRenderFns } from "./VoteFeature.vue?vue&type=template&id=130f714e&scoped=true&"
import script from "./VoteFeature.vue?vue&type=script&lang=js&"
export * from "./VoteFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f714e",
  null
  
)

export default component.exports